import { useTranslation } from 'react-i18next';
import React from 'react';
import { PayoutDetails } from '../../interfaces/timeline';
import styles from '../../product-timeline.module.scss';

const PaymentInfoItem: React.FC<{
  label: string;
  value: string;
}> = ({ label, value }) => {
  return (
    <div className={styles.ordersSales__mainRight__steps__step__box__paymentInfo__item}>
      <div className={styles.ordersSales__mainRight__steps__step__box__paymentInfo__item__label}>{label}</div>
      <div className={styles.ordersSales__mainRight__steps__step__box__paymentInfo__item__value}>{value}</div>
    </div>
  );
};

const PaymentInfoView: React.FC<{
  paymentDetail: PayoutDetails;
}> = ({ paymentDetail }) => {
  const { paymentBy, formattedAmount, account, message } = paymentDetail || {};
  const { t } = useTranslation();

  return (
    <div className={styles.ordersSales__mainRight__steps__step__box__paymentInfo}>
      <div>
        <PaymentInfoItem
          label={t('TIMELINE.PAYMENT_INFO.EARNINGS')}
          value={formattedAmount}
        />

        <PaymentInfoItem
          label={t('TIMELINE.PAYMENT_INFO.PAYMENT_BY')}
          value={paymentBy}
        />

        <PaymentInfoItem
          label={t('TIMELINE.PAYMENT_INFO.ACCOUNT')}
          value={account}
        />
      </div>

      {/* Warning message */}
      {message && (
        <div className={styles.ordersSales__mainRight__steps__step__box__paymentInfo__warningMessage}>{message}</div>
      )}
    </div>
  );
};

export default PaymentInfoView;
